// depends on global TWEEN

/**
 * @file slotline.js
 * @desc This module contains SlotLine class definition.
 * @author Igor Kling <kling.igor.ksi@gmail.com>
 * @version 1.0.dev
 * @copyright 2016 (c) KSI Corporation
 * */

(/** @lends <global> */function (global) {
    'use strict';

    var SlotFrame = require('./slotframe').SlotFrame;
    
    /**
     * Constructs slot line object.
     * @class
     * @constructor
     * @param {String} lineName Base name of line resource (original filename)
     * @param {Object} lineConfig Line configuration object
     * @param {String} frameName Base name of frame resource (original filename)
     * @param {Object} frameConfig Frame configuration object
     * @param {Object} barrelConfig Barrel configuration object
     * @name SlotLine
     * @classdesc This is a GUI component. Slot line aggregates symbol {@link SlotFrame|frames} and response for proper visualization.
     * @extends {PIXI.Container}
     * @requires {slotframe}
     * @tutorial 1.7-adding-lines-frames-billets
     * */
    var SlotLine = function(lineName, lineConfig, frameName, frameConfig, barrelConfig) {

        PIXI.Container.call(this);

        // куски линии
        this._segments = [];
        this._trajectory = lineConfig.trajectory;
        this._cropedPositions = [];

        // массив рамок
        this._frames = [];

        this._rows = barrelConfig.rows;
        this._reels = barrelConfig.reels;

        var self = this;

        var createSegment = function(segmentName, config){

            var segment = new PIXI.Sprite(PIXI.utils.TextureCache[segmentName + ".png"]);
            segment.x = config.chunks[segmentName].x;
            segment.y = config.chunks[segmentName].y;

            self.addChild(segment);
            self._segments.push(segment);
        };

        // всегда в массиве сегментов вырезаемые куски будут первыми
        for (var i = 0; i < 5; ++i) {
            var segmentName = lineName + "_cell_" + i.toString();
            var segment = lineConfig.chunks[segmentName];
            if (segment) {
                createSegment(segmentName, lineConfig);
            }
        }

        var beginSegmentName = lineName + "_begin";
        if (lineConfig.chunks[beginSegmentName]) {
            createSegment(beginSegmentName, lineConfig);
        }

        var endSegmentName = lineName + "_end";
        if (lineConfig.chunks[endSegmentName]) {
            createSegment(endSegmentName, lineConfig);
        }

        for (i = 0; i < 4; ++i) {
            var segmentName = lineName + "_gap_" + i.toString();
            var segment = lineConfig.chunks[segmentName];
            if (segment) {
                createSegment(segmentName, lineConfig);
            }
        }

        if (frameConfig !== undefined && frameConfig !== null) {
            this.hasFrames = true;
            for (i = 0; i < 5; ++i) {
                var frame = new SlotFrame(frameName, frameConfig);
        
                var col = i;
                var row = lineConfig.trajectory[i];
        
                frame.x = barrelConfig.position.x + col * (barrelConfig.cellSize.width + barrelConfig.reelGap) + (barrelConfig.frameOffset ? barrelConfig.frameOffset.x : 0);
                frame.y = barrelConfig.position.y + row * (barrelConfig.cellSize.height + (barrelConfig.cellGap || 0)) + (barrelConfig.frameOffset ? barrelConfig.frameOffset.y : 0);
                frame.hide(); // изначально не видима
        
        
                this.addChild(frame);
                this._frames.push(frame);
            }
        }
    };

    SlotLine.prototype = Object.create(PIXI.Container.prototype);

    SlotLine.prototype.constructor = SlotLine;


    /**
     * Makes line visible
     * @memberOf SlotLine
     * */
    SlotLine.prototype.show = function() {
        this.visible = true;
    };
    
    /**
     * Makes line hidden
     * @memberOf SlotLine
     * */
    SlotLine.prototype.hide = function() {
        this.visible = false;
    };

    /**
     * Crops line by hiding segments on specified positions
     * @param {Number[]} positions Array of barrel positions
     * @memberOf SlotLine
     */
    SlotLine.prototype.cutPositions = function(positions) {

        for (var i = 0; i < positions.length; ++i) {

            var idx = positions[i] / this._rows | 0;
            var row = positions[i] % this._rows | 0;

            if (this._trajectory[idx] === row) {
                this._cropedPositions.push(idx);
            }
        }
    };

    /**
     * Restores line cropped segments.
     * @memberOf SlotLine
     */
    SlotLine.prototype.restoreLine = function() {
        for (var i = 0; i < 5; ++i) {
            this._segments[i].visible = true;
            if (this.hasFrames) {
                this._frames[i].visible = false;
            }
        }

        this._cropedPositions = [];
    };

    /**
     * Fades in line.
     * @param {Number} [time] Time in milliseconds
     * @memberOf SlotLine
     * */
    SlotLine.prototype.fadeIn = function(time) {

        time = time || 200; // ms

        this.show();

        for (var i = 0; i < this._segments.length; ++i) {

            var component = null;

            //sadly, IE has no ".find()", so typing the equivalent here:
            var foundCropPosition = undefined;
            for ( var croppedPositionIndex in this._cropedPositions )
            {
                if ( this._cropedPositions[ croppedPositionIndex ] === i )
                {
                    foundCropPosition = i;
                    break;
                }
            }
            
            if (
                this._cropedPositions.length > 0 &&
                foundCropPosition !== undefined
            ) {
                this._segments[i].visible = false;
                if (this.hasFrames) {
                    component = this._frames[i];
                }
            }
            else {
                component = this._segments[i];
            }

            if (component) {
                component.visible = true;
                component.alpha = 0;
    
                var tween = new TWEEN.Tween(component)
                    .to({ alpha: 1}, time)
                    .start();
            }
        }
    };
    
    /**
     * Fades out line.
     * @param {Number} [time] Time in milliseconds
     * @memberOf SlotLine
     * */
    SlotLine.prototype.fadeOut = function(time) {
    
        time = time || 200; // ms

        var self = this;

        for (var i = 0; i < this._segments.length; ++i) {

            var component = null;

            //sadly, IE has no ".find()", so typing the equivalent here:
            var foundCropPosition = undefined;
            for ( var croppedPositionIndex in this._cropedPositions )
            {
                if ( this._cropedPositions[ croppedPositionIndex ] === i )
                {
                    foundCropPosition = i;
                    break;
                }
            }

            if (
                this._cropedPositions.length > 0 &&
                foundCropPosition !== undefined
            ) {
                this._segments[i].visible = false;
                if (this.hasFrames) {
                    component = this._frames[i];
                }
            }
            else {
                component = this._segments[i];
            }
            
            if (component) {
                component.visible = true;
                component.alpha = 1;
    
                var tween = new TWEEN.Tween(component)
                    .to({ alpha: 0}, time)
                    .onComplete(function() {
                        self.hide();
                    })
                    .start();
            }
        }
    };

    global.SlotLine = SlotLine;
}(typeof module === 'object' && module.exports || this));


//////////////////
// WEBPACK FOOTER
// ./src/library/slotline.js
// module id = 34
// module chunks = 0